import React, { createContext, useContext } from 'react';
import useFlatComments, {
  flatCommentsQuerySelectors,
} from '../../../queries/useFlatComments';

const Context = createContext();

export const useCommentsQuery = () => useContext(Context);

export const CommentsQueryProvider = ({
  addressId,
  queryOptions,
  children,
}) => {
  const { data, isFetching, refetch } = useFlatComments(addressId, {
    select: flatCommentsQuerySelectors.selectReverse,
    ...queryOptions,
  });

  return (
    <Context.Provider value={{ data, isFetching, refetch }}>
      {children}
    </Context.Provider>
  );
};
